module.exports = __webpack_public_path__ + "img/pres_1.cd0b5dea.jpg";